import api from '@/api';

import { API_BASE_URL } from '..';
import {
  AverageTicketParams,
  BillingExpenseRevenueParams,
  BillingOverviewParams,
  BillingPassAverageTicketParams,
  CashFlowParams,
  ChartResponse,
  ComparasionInsurersParams,
  CostFixedVariableParams,
  CostSalesParams,
  ExpensesIncomeParams,
  PartsServicesParams,
} from './ManagementChart.types';

const CONTROLLER_URL = `${API_BASE_URL}/workorders/management-charts`;

const managementChartServices = {
  async averageTicket(params: AverageTicketParams) {
    const result = (await api.get(
      `${CONTROLLER_URL}/average-ticket`,
      params,
    )) as unknown;

    return result as ChartResponse;
  },

  async expenseIncome(params: ExpensesIncomeParams) {
    const result = (await api.get(
      `${CONTROLLER_URL}/expenses-income`,
      params,
    )) as unknown;

    return result as ChartResponse;
  },

  async partsServices(params: PartsServicesParams) {
    const result = (await api.get(
      `${CONTROLLER_URL}/parts-services`,
      params,
    )) as unknown;

    return result as ChartResponse;
  },

  async cashFlow(params: CashFlowParams) {
    const result = (await api.get(
      `${CONTROLLER_URL}/CashFlow`,
      params,
    )) as unknown;

    return result as ChartResponse;
  },

  async costFixedVariable(params: CostFixedVariableParams) {
    const result = (await api.get(
      `${CONTROLLER_URL}/CostFixedVariable`,
      params,
    )) as unknown;

    return result as ChartResponse;
  },

  async comparisonInsurers(params: ComparasionInsurersParams) {
    const result = (await api.get(
      `${CONTROLLER_URL}/comparison-insurers`,
      params,
    )) as unknown;

    return result as ChartResponse;
  },

  async costSales(params: CostSalesParams) {
    const result = (await api.get(
      `${CONTROLLER_URL}/cost-sales`,
      params,
    )) as unknown;

    return result as ChartResponse;
  },

  async billingOverview(params: BillingOverviewParams) {
    const result = (await api.get(
      `${CONTROLLER_URL}/billing-overview`,
      params,
    )) as unknown;

    return result as ChartResponse;
  },

  async billingPassAverageTicket(params: BillingPassAverageTicketParams) {
    const result = (await api.get(
      `${CONTROLLER_URL}/billing-pass-average-ticket`,
      params,
    )) as unknown;

    return result as ChartResponse;
  },

  async billingExpenseRevenue(params: BillingExpenseRevenueParams) {
    const result = (await api.get(
      `${CONTROLLER_URL}/BillingExpensesRevenue`,
      params,
    )) as unknown;

    return result as ChartResponse;
  },
};
export default managementChartServices;
